<wl-content-section [id]="id()" [theme]="theme()">
  <wl-content-single-column-text-section
    [aside]="aside()"
    [heading]="rendering().fields?.heading"
    [richText]="rendering().fields?.richText"
  >
    @if (showAppStoreButtons()) {
      <wl-app-store-buttons
        app-store-buttons
        [appStoreButtonLink]="appStoreButton()"
        [googlePlayButtonLink]="googlePlayButton()"
      />
    }
    @if (showCallToActionButton()) {
      <div class="d-flex flex-column flex-md-row gap-2" call-to-action-button>
        @if (showPrimaryButton()) {
          <ng-container
            *ngTemplateOutlet="
              button;
              context: { button: primaryButton(), variant: 'secondary' }
            "
          />
        }
        @if (showSecondaryButton()) {
          <ng-container
            *ngTemplateOutlet="
              button;
              context: { button: secondaryButton(), variant: 'tertiary' }
            "
          />
        }
      </div>
    }
  </wl-content-single-column-text-section>
</wl-content-section>

<ng-template #button let-button="button" let-variant="variant">
  <crnt-button-alt
    class="flex-grow-1 flex-md-grow-0"
    [variant]="variant"
    wlTrackLink
    [trackLinkInfo]="{
      rendering: {
        componentName: 'ContentSectionTextContainerComponent',
      },
      field: button.value.text || '',
      eventType: 'button-click',
      type: 'button',
    }"
  >
    <a *wlGenericLink="button"></a>
  </crnt-button-alt>
</ng-template>
